import { Image } from "@chakra-ui/react";
import logo from "../../assets/logos/PNG/logo_horizontal_verde_branco2.png";

export function Logo() {
  
  return (
    <Image 
      src={logo}
      width={"120px"}
      my={"40px"}
      objectFit="contain"
    />
  );
}
